import { render, staticRenderFns } from "./AddOns.vue?vue&type=template&id=21e6aa47&scoped=true"
import script from "./AddOns.vue?vue&type=script&lang=js"
export * from "./AddOns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e6aa47",
  null
  
)

export default component.exports